// extracted by mini-css-extract-plugin
export default {"shimmer":"EmbeddedPreviewFundingMethod_shimmer__dDZpk"};